import { render, staticRenderFns } from "./config_showroom.vue?vue&type=template&id=49e631e0&"
import script from "./config_showroom.vue?vue&type=script&lang=js&"
export * from "./config_showroom.vue?vue&type=script&lang=js&"
import style0 from "./config_showroom.vue?vue&type=style&index=0&id=49e631e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports